import create from 'zustand';

const useVariantStore = create((set) => ({
  variants: [],
  deletedVariants: [],
  editedVariants: [],
  setInvalidVariants: [],
  hasExistingSKUs: false,
  skusValidated: false,
  setVariants: (variants) => set({ variants }),
  setHasExistingSKUs: (hasExistingSKUs) => set({ hasExistingSKUs }),
  setSkusValidated: (skusValidated) => set({ skusValidated }),
  resetState: () => set({
    variants: [],
    hasExistingSKUs: false,
    skusValidated: false,
  })
}));

export default useVariantStore;
